import { ToneDto } from 'src/com/sixdee/crbtportal/core/dto/tonedto';
import { ToneRowOptionsPrivilage } from 'src/com/sixdee/crbtportal/ui/toolkit/toneoptions/tone/tonerowcomponent';
import { BaseContext } from 'src/com/sixdee/crbtportal/utils/basecontext';
import { PlayerComponentCSSStyle } from '../../../../toolkit/player/playercss';
import {  AudioPlayerWithProgressImpl } from '../../../../toolkit/player/playerwithprogress/playerwithprogressimpl';
import { UIComponentProps, UIComponentState, UIComponentHandler, UIComponentImpl, UIDataModel } from '../../../../toolkit/uicomponent';
import { UIComponentCSSStyle } from '../../../../toolkit/uicomponentcss';
import { UIComponentView } from '../../../../toolkit/uicomponentview';
import { ToneCardCSSStyle } from '../../featuredcategory/viewmodel/tonecard/tonecardcssstyle';
import { ProfileTuneCardViewImpl } from './profiletunecardview';



export interface ProfileTuneCardComponentProps extends UIComponentProps
{
    toneDto: ToneDto;
    position: number;
    cardStyle :ToneCardCSSStyle;
    marginTop: string;
    toneRowOptionsPrivilage: ToneRowOptionsPrivilage;

    audioPlayerWithProgress: AudioPlayerWithProgressImpl;
    playerCSSStyle: PlayerComponentCSSStyle;
    mobilePlayerCSSStyle:PlayerComponentCSSStyle;
    isPlayInitial?: boolean;
}

export interface ProfileTuneCardComponentState extends UIComponentState
{

   toneRowOptionsPrivilage: ToneRowOptionsPrivilage;
}

export interface ProfileTuneCardComponentHandler extends UIComponentHandler
{
    onSettingsClick():void;
}

export class ProfileTuneCardComponent extends UIComponentImpl<ProfileTuneCardComponentProps, ProfileTuneCardComponentState, UIDataModel> implements ProfileTuneCardComponentHandler
{
    constructor(props: ProfileTuneCardComponentProps)
    {
        super(props);

        this.state = {toneRowOptionsPrivilage: props.toneRowOptionsPrivilage};
    }

    componentDidMount()
    {
        (this.getView() as ProfileTuneCardViewImpl).setPlayerWithProgress(this.props.audioPlayerWithProgress);
        // if(this.props.isPlayInitial !== undefined && this.props.isPlayInitial)
        // {
        // }
    }

    playStart()
    {
        (this.getView() as ProfileTuneCardViewImpl).onPlayStart();
    }

    UNSAFE_componentWillReceiveProps(nextProps: ProfileTuneCardComponentProps)
    {
        (this.getView() as ProfileTuneCardViewImpl).setPlayerWithProgress(nextProps.audioPlayerWithProgress);
        // if(this.props.isPlayInitial !== undefined && this.props.isPlayInitial)
        // {
        //     (this.getView() as ToneCardViewImpl).onPlayStart();
        // }
    }


    onSettingsClick(): void 
    {
        // this.props.context.getRedirectionHandler().routeNextFeature(this.props.context.getRoutingPath() +
        //         "/" + RoutingFeatures.PROFILE_TUNES, false);
        
    }

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new ProfileTuneCardViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return this.props.cardStyle;
    }

    componentWillReceiveProps(nextProps: ProfileTuneCardComponentProps)
    {
        this.setState({toneRowOptionsPrivilage: nextProps.toneRowOptionsPrivilage});
    }

    onSelected(): void 
    {
    //    this.props.onSelected(this.props.toneDto, this.props.position);
    }

    componentWillUnmount()
    {
        this.props.audioPlayerWithProgress.unRegisterEvents();
    }

}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/profiletunes/profiletunecard/profiletunecardcomponent.tsx